import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { verifyAndLoginAction } from '../../redux/actions/authAction';
import { useDispatch } from 'react-redux';
import errorToast from '../../components/toasts/errorToast';
import successToast from '../../components/toasts/successToast';
import { PORTAL_ORIGIN } from '../../redux/config';
import { useAuth } from '../../context/AuthContext';

const RedirectLogin = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { fetchMe } = useAuth();
    const [loading, setloading] = useState(true);

    const onSuccess = async (data) => {
        await fetchMe();
        successToast(data.data.message);
        localStorage.setItem("active_tab", 'Overview');
        setloading(false);
        navigate('/over-view');
    };

    useEffect(() => {
        const handleMessage = (event) => {
            setloading(true);
            if (event.origin !== PORTAL_ORIGIN || !event.data?.redirectToken) return;
            window.removeEventListener('message', handleMessage);
            const { redirectToken } = event.data;

            dispatch(verifyAndLoginAction(
                { token: redirectToken },
                onSuccess,
                (data) => { errorToast(data.data.message); localStorage.clear(); sessionStorage.clear(); setloading(false); navigate('/') }
            ));
        };

        window.addEventListener('message', handleMessage);
        window.opener?.postMessage({ type: 'READY' }, PORTAL_ORIGIN);

        return () => window.removeEventListener('message', handleMessage);
    }, [])

    return (
        <div>{loading ? 'Verifying and redirecting...' : "Redirecting..."}</div>
    )
}

export default RedirectLogin
